import variables from "common/variables";

function getToken() {
  return "";
}

function storeToken(token) {
  if (variables.isRememberMe) {
    localStorage.setItem("token", token);
  } else {
    sessionStorage.setItem("token", token);
  }
  const decodedToken = jwtDecode(token);
  const roles = decodedToken.roles.split(",");
  let currentRole = "borker";
  const operatorRoles = roles.filter((x) => x === "operator");
  if (operatorRoles.length > 0) {
    currentRole = "operator";
  }
  localStorage.setItem("currentRole", currentRole);
}

function getName() {
  return "";
}

async function viewFile(url, token) {
  // Change this to use your HTTP client
  const blob = await (
    await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
  ).blob();
  const _url = window.URL.createObjectURL(blob);
  window.open(_url, "_blank").focus();
}

function deleteToken() {
  localStorage.removeItem("token");
  sessionStorage.removeItem("token");
  localStorage.removeItem("currentRole");
}

function getCurrentRole() {
  return localStorage.getItem("currentRole");
}

function currentUserRoles() {
  return "";
}

function getId() {
  const token = getToken();
  const decodedToken = jwtDecode(token);
  return decodedToken.user_id;
}

function caculateLifetime(prop) {
  const installedYear = Number(prop.installed_date.split(" ")[0].split("-")[0]);

  let curAcc = 0;
  const lifetimeSeries = [];
  lifetimeSeries.push(100);
  for (let i = 0; i < prop.exceedance_levels.length; i += 1) {
    curAcc += prop.exceedance_levels[i][1];
    lifetimeSeries.push(100 + curAcc);
  }

  for (let i = 0; i < prop.lifetime_rates.length; i += 1) {
    lifetimeSeries.push(prop.lifetime_rates[i]);
  }

  const years = prop.exceedance_levels.length + prop.lifetime_rates.length;

  curAcc = 0;
  const fpLifetimeSeries = [];
  fpLifetimeSeries.push(100);
  for (let i = 0; i < prop.exceedance_levels.length; i += 1) {
    curAcc += prop.exceedance_levels[i][1];
    fpLifetimeSeries.push(100 + curAcc);
  }
  for (let i = 0; i < prop.fp_lifetime_rates.length; i += 1) {
    fpLifetimeSeries.push(prop.fp_lifetime_rates[i]);
  }

  const fpYears = prop.exceedance_levels.length + prop.fp_lifetime_rates.length;

  // eslint-disable-next-line no-param-reassign
  prop.lifetime_series = lifetimeSeries;
  // eslint-disable-next-line no-param-reassign
  prop.fp_lifetime_series = fpLifetimeSeries;
  // eslint-disable-next-line no-param-reassign
  prop.years = years;
  // eslint-disable-next-line no-param-reassign
  prop.fp_years = fpYears;
  // eslint-disable-next-line no-param-reassign
  prop.installed_year = installedYear;

  return installedYear + years;
}

function estimateBill(siteNumber, dayNumber) {
  return (
    estimateUploadData(dayNumber) + estimateDataTransfer(dayNumber) + estimateBasicFee(siteNumber)
  );
}

function estimateBasicFee(siteNumber) {
  return siteNumber * 13.2;
}

function estimateUploadData(dayNumber) {
  return 0.02 * dayNumber;
}

function estimateDataTransfer(dayNumber) {
  return 0.001 * dayNumber;
}

export {
  getToken,
  storeToken,
  getCurrentRole,
  currentUserRoles,
  deleteToken,
  getName,
  viewFile,
  getId,
  caculateLifetime,
  estimateBill,
  estimateBasicFee,
  estimateUploadData,
  estimateDataTransfer,
};
